import { Loader } from '@mantine/core';
import { IconSatellite } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './analysis-loader.module.css';

/* eslint-disable-next-line */
export interface AnalysisLoaderProps {}

export function AnalysisLoader(_props: AnalysisLoaderProps) {
  const { t } = useTranslation(['plot'], { useSuspense: false });

  return (
    <div className={styles.container} data-testid="analysis-loader">
      <div aria-hidden className={styles.iconWrap}>
        <IconSatellite size={22} stroke={1.5} />
      </div>
      <p className={styles.message}>{t('plot:preparing_analysis')}</p>
      <Loader color="var(--lidea-accent, #43a117)" size="sm" type="dots" />
    </div>
  );
}

export default AnalysisLoader;
